import React from 'react';
import { Stack, Typography } from '@mui/material';
import { ReactComponent as SearchError } from 'assets/images/ErrorState/SearchError.svg';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';

export const ResourceSearchErrorState = () => {
  const { translation } = useTranslationContext();

  return (
    <Stack alignItems="center" spacing={2} sx={{ py: 6 }}>
      <SearchError role="img" aria-label="Search error" width={240} height={250} />
      <Typography
        variant="headline"
        textAlign="center"
        fontWeight={500}
        sx={{ color: (theme) => theme.palette.primary.main }}
      >
        {translation('server_error_on_checklist_headline')}
      </Typography>
      <Typography
        variant="callout"
        textAlign="center"
        sx={{ color: (theme) => theme.palette.grey[800] }}
      >
        {translation('server_error_on_checklist_body')}
      </Typography>
    </Stack>
  );
};

ResourceSearchErrorState.displayName = 'ResourceSearchErrorState';
